import { Observable } from 'rxjs';

export class FileUpload {

    $key: string;
    name: string;
    url: Observable<string>;
    file: File;

    constructor(file: File) {
      this.file = file;
    }
  }
